"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TIMEOUT = exports.headers = void 0;
const base64Encode_1 = __importDefault(require("./base64Encode"));
const headers = (apiKey, clientVersion) => ({
    Authorization: `Basic ${(0, base64Encode_1.default)(`u:${apiKey}`)}`,
    "X-PrefabCloud-Client-Version": clientVersion,
});
exports.headers = headers;
exports.DEFAULT_TIMEOUT = 10000;
